export const TAG_FRAGMENT = `
  fragment TagFragment on Tag {
    id
    description
    slug
    title
    type
    images {
      ...ImageFragment
    }
    refs {
      id
      uri
      targetType
    }
    labels
    config {
      ...ConfigFragment
    }
  }
  `;
